<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form label-width="120px" :model="dataForm">
        <el-form-item
          label="基础信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="求助人姓名："
              >{{ dataForm.Name }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="性别："
              >{{ showSex(dataForm.Sex) }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="户籍所在地："
              >{{ dataForm.NationPlace }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="年龄："
              >{{ dataForm.Age }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号："
              >{{ dataForm.IdentityCard }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="手机号："
              >{{ dataForm.Phone }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="确诊病型："
              >{{ dataForm.Diagnosis }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="家庭住址："
              >{{ dataForm.Address }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="申请救助事由："
              >{{ dataForm.Describe }}
            </el-form-item></el-col
          >
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="附件：">
              <of-upload
                class="upload-demo"
                list-type="fileList"
                @onPreview="onFilePreview"
                :fileList="fileList"
                :class="{ hideFile: true }"
              >
              </of-upload> </el-form-item
          ></el-col>
        </el-row> -->
        <el-form-item
          label="家人联系方式"
          style="background-color: #f8f8f9"
          label-width="110px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人姓名："
              >{{ dataForm.ContactName }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="与申请人关系："
              >{{ dataForm.RelationShip }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人电话："
              >{{ dataForm.ContactPhone }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="身份证号："
              >{{ dataForm.ContactIdCard }}
            </el-form-item></el-col
          >
        </el-row>
        <el-form-item
          label="银行账户"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名："
              >{{ dataForm.BankUserName }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="银行："
              >{{ dataForm.Bank }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="银行卡号："
              >{{ dataForm.BankCardNo }}
            </el-form-item></el-col
          >
        </el-row>
        <el-form-item
          label="相关文件"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <!-- <el-row>
          <el-col :span="12">
            <div class="label-title">
              求助人求助信
            </div>
              <el-image 
                v-for="item in arrFileOne" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col>
          <el-col :span="12">
            <div class="label-title">
              家庭成员居民身份证
            </div>
              <el-image 
                v-for="item in arrFileTwo" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <div class="label-title">
              家庭成员户口簿
            </div>
              <el-image 
                v-for="item in arrFileThree" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col>
          <!-- <el-col :span="12">
            <div class="label-title">
              病理、化验报告、出（入）院记录等
            </div>
              <el-image
                v-for="item in arrFileFour" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col> -->
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <div class="label-title">
              医院病理检查报告或化验报告
            </div>
              <el-image 
                v-for="item in arrFileFive" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col> -->
          <!-- <el-col :span="12">
              <div class="label-title">
              收费明细清单或有效发票
            </div>
              <el-image  
                v-for="item in arrFileSix" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col> -->
          <el-col :span="12">
              <div class="label-title">
              疾病诊断证明
            </div>
              <el-image  
                v-for="item in arrFileSeven" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <div class="label-title">
              当地村（居）委会出具的家庭困难证明
            </div>
              <el-image  
                v-for="item in arrFileEight" :key="item.id"
                style="width: 100px; height: 100px; padding: 5px;"
                :src="item" 
                :preview-src-list="[item]">
              </el-image>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      fileList: [], //附件数组
      width: "800px",
      typeName: "", //分类名称
      arrFileOne: [],
      arrFileTwo: [],
      arrFileThree: [],
      arrFileFour: [],
      arrFileFive: [],
      arrFileSix: [],
      arrFileSeven: [],
      arrFileEight: [],
    };
  },
  components: {
    workbenchDetail,
    OfUpload,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryBigSickApplyById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          // that.getlistfile();
          // that.arrFileOne = JSON.parse(that.dataForm.FileOne)
          // that.arrFileTwo = JSON.parse(that.dataForm.FileTwo)
          that.arrFileThree = JSON.parse(that.dataForm.FileThree)
          // that.arrFileFour = JSON.parse(that.dataForm.FileFour)
          // that.arrFileFive = JSON.parse(that.dataForm.FileFive)
          // that.arrFileSix = JSON.parse(that.dataForm.FileSix)
          that.arrFileSeven = JSON.parse(that.dataForm.FileSeven)
          that.arrFileEight = JSON.parse(that.dataForm.FileEight)
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditBigSickApply(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.Files === undefined || that.dataForm.Files === null) {
        return;
      }
      let params = { Id: that.dataForm.Files };
      api.QueryBigSickApplyFileByIds(params).then((res) => {
        if (res.data.Code == 0) {
          let fileList = res.data.Data;
          fileList.forEach((item) => {
            that.fileList.push({url:item.Url,name:item.FileName});
          });
        }
      });
    },
    //下载附件
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hidePic >>> .el-upload-list__item-delete {
  display: none !important;
}
.hidePic >>> .el-icon-close {
  display: none !important;
}
.hidePic >>> .el-icon-close-tip {
  display: none !important;
}
.hideFile >>> .el-upload-list__item-delete {
  display: none !important;
}
.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
.el-form >>> .el-form-item__label {
  font-weight: 500;
}
.label-title {
  padding: 10px 0;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>